import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { usePathFilterTracking } from "../hooks/usePathFilterTracking";
import clsx from "clsx";
import React from "react";
export default function StaticButtonGroup({ filter, onAfterChange, }) {
    var _a;
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackSegmentCommit } = usePathFilterTracking();
    const param = filter.id;
    const current = (_a = selectedState[param]) !== null && _a !== void 0 ? _a : "";
    function handleSelect(value) {
        const prev = selectedState[param];
        const next = value ? value : undefined;
        const newState = Object.assign(Object.assign({}, selectedState), { [param]: next });
        dispatch({ type: "set_selected", payload: newState });
        if (filter.tracking && prev !== next) {
            trackSegmentCommit(filter, newState);
        }
        onAfterChange === null || onAfterChange === void 0 ? void 0 : onAfterChange(newState);
    }
    return (<div className="flex h-10 rounded-full border border-[#A1A2A5] overflow-hidden p-1">
      {filter.options.map((option) => (<button key={option.value} type="button" onClick={() => handleSelect(option.value)} className={clsx(`flex-1 h-full text-sm rounded-full`, current === option.value ? "bg-[#1C2022] text-white" : "bg-white")}>
          {option.label}
        </button>))}
    </div>);
}
